import React from 'react';
import GoogleMapReact from 'google-map-react';

import { MapModalContext } from '../../utils/contexts';
import { Container, Modal, Content } from '../../styles/modals/generic-modal';
import Header from './parts/modal-header';

export default function MapModal(props) {

	return(
		<MapModalContext.Consumer>
			{
				({ isOpen, setIsOpen, center }) => {

          if (isOpen) {
            window.history.pushState(null, null, window.location.pathname);
            window.addEventListener('popstate', (e) => {
              e.preventDefault();
              setIsOpen(false)
            });
          }

					return <Container visible={isOpen} className="bg" onClick={(e) => e.target.classList.contains('bg') && setIsOpen(false)}>
						<Modal>
							<Header onCloseClick={() => setIsOpen(false)} />
							<Content verticalCenter fullWidth >
								{
									isOpen
									? <div className="map-container" style={{ height: '70vh', width: '100%' }} >
										<GoogleMapReact
											bootstrapURLKeys={{ key: 'AIzaSyB_QwI359vtBMgI2yyhQN-4l3PYnmTqeXw' }}
											defaultCenter={center}
											defaultZoom={18}
										/>
									</div>
									: null
								}
							</Content>
						</Modal>
					</Container>
        }
			}
		</MapModalContext.Consumer>
	);
}